<header class="p-3 mb-3 border-bottom">
	<div class="container">
		<div class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
			<a href="/" class="d-flex align-items-center mb-2 mb-lg-0 link-body-emphasis text-decoration-none">
				<img src="https://test.kula.pandadigital.co.za/assets/images/Panda%20-%20Icon%20(Dark%20Background).png" style="height: 3em;" />
			</a>
		</div>
	</div>
</header>
<div class="container mt-5">
	<div class="row justify-content-center">
		<div class="col text-center">
			<img src="https://test.kula.pandadigital.co.za/assets/images/logo1.jpg" style="height: 3em;" />
			<h1 class="text-dark"> <b>Secure File Access</b></h1>

			@if (disableValidate) {
				<div class="title text-danger">{{error}}</div>			
			} @else {
				<form (ngSubmit)="onSubmit()" [formGroup]="otpForm" class="mx-auto">
					<div class="title">Please enter the OTP you received via SMS</div>
					<div class="form-floating mb-3">
						<input type="text" class="form-control" id="otp" placeholder="OTP" formControlName="otp" maxlength="6" [readonly]="disableValidate" />
						@if (otpForm.get('otp')?.touched && otpForm.get('otp')?.invalid) {
							<div class="text-danger small">OTP must be numbers only, and be exactly 6 digits.</div>
						}
						<label for="otp">OTP</label>
					</div>

					<button type="submit" class="btn btn-primary rounded-3" [disabled]="disableValidate">
						Validate
					</button>
				</form>
			}
		</div>
	</div>
</div>


